import React from "react";

const Shimmer = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 w-full max-w-7xl p-4 animate-pulse">
        {Array(12).fill("").map((_, i) => (
          <div
            key={i}
            className="p-3 shadow-lg rounded-xl bg-white"
          >
            {/* Image placeholder */}
            <div className="w-full h-48 sm:h-56 lg:h-64 bg-gray-300 rounded-lg"></div>
            {/* Text placeholder */}
            <div className="mt-3 h-4 w-3/4 bg-gray-300 rounded"></div>
            <div className="mt-2 h-4 w-1/2 bg-gray-300 rounded"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Shimmer;
